import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { FocusViewModule } from '@tc/focus-view';
import { SectionHeadingModule } from '@tc/section-heading';
import { SetupGridModule } from '../../../widgets/framework/ag-grid-custom-components/components/setup-grid/setup-grid.module';
import { DispatchDataModalModule } from '../dispatch-data-modal/dispatch-data-modal.module';
import { DocumentDetailFocusViewComponent } from './document-detail-focus-view.component';

@NgModule({
    declarations: [DocumentDetailFocusViewComponent],
    imports: [
        CommonModule,
        TranslateModule.forChild(),
        FocusViewModule,
        MatButtonModule,
        MatTooltipModule,

        SectionHeadingModule,
        SetupGridModule,
        DispatchDataModalModule
    ],
    exports: [DocumentDetailFocusViewComponent],
    entryComponents: [DocumentDetailFocusViewComponent]
})
export class DocumentDetailFocusViewModule {}
